import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

import { AccessExplainerDetails, AccessType } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetDataSecurityAccessComparisonRequest = DynamicQueryParams & {
	accessId: Array<string>;
    accessType: Array<AccessType>;
};

export type GetDataSecurityAccessComparisonResponse = AccessExplainerDetails;

export const getDataSecurityAccessComparison =
	createGetEndpoint<GetDataSecurityAccessComparisonRequest, GetDataSecurityAccessComparisonResponse>(
		(request) => `/api/v3/salesforce/data-access/compare?${getQueryString(request)}`
	);
